export const enum SetupEvent {
  CheckInstallGuideClicked = 'Check install guide clicked',
  CompanySizeStepCompleted = 'Company size step completed',
  ConnectingChannelsStepCompleted = 'Channels step completed',
  DownloadDesktopAppClicked = 'Download desktop app clicked',
  DownloadDesktopAppVisited = 'Download desktop app step visited',
  DownloadMobileAppClicked = 'Download mobile app clicked',
  DownloadMobileAppVisited = 'Download mobile app step visited',
  GoBackPreviousStep = 'Go back to previous step clicked',
  GoToNextStepAction = 'Go to next step action',
  IllDoItMyselfClicked = "I'll do it myself clicked",
  InstallCodeIntentCompleted = 'Code installation intent completed',
  InstallCodeReminderCompleted = 'Install code reminder completed',
  InstallCodeReminderDisplayed = 'Install code reminder displayed',
  InstallCodeStepContinueClicked = 'Code installation step continue clicked',
  InviteDeveloperStepCompleted = 'Developer invitation completed',
  InviteTeamStepCompleted = 'Team invitation completed',
  InviteYourDeveloperClicked = 'Invite your developer clicked',
  NameStepCompleted = 'Name step completed',
  OnboardingFinished = 'Onboarding finished',
  SignupCompleted = 'Sign up completed',
  SkipInstallCodeClicked = 'Skip install code clicked',
  TeamStepSkipped = 'Team step skipped',
  UpdateCreditCardDetailsClicked = 'Update credit card details clicked',
  WebsiteStepCompleted = 'Website step completed',
}
